import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classes from "./button.module.css";
const Button = forwardRef(function ButtonComp(props, ref) {
  const { className, ...otherProps } = props;
  const cls = `${className} ${classes.root}`;
  return /* @__PURE__ */ jsx("button", { type: "button", ...otherProps, className: cls, ref });
});
export {
  Button
};
//# sourceMappingURL=Button.js.map
